import React, { PropsWithChildren } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  cn,
} from '@sandtech-hub-monorepo/ui-kit';
import { PencilIcon, PlusCircleIcon } from 'lucide-react';

interface Props extends PropsWithChildren {
  editable?: boolean;
  title?: string;
  action?: () => void;
  plusInsteadOfPencil?: boolean;
  className?: string;
}

export const ProfileCard = ({
  className = '',
  editable,
  title,
  action,
  plusInsteadOfPencil,
  children,
}: Props) => {
  return (
    <Card
      className={
        'border-border-secondary rounded-sm flex flex-col ' + className
      }
    >
      <CardHeader
        className={cn(
          'flex flex-row justify-between items-center font-semibold text-lg',
          editable && action ? '-my-2' : ''
        )}
      >
        {title && <div>{title}</div>}
        {editable && action && (
          <div
            onClick={action}
            className="rounded-full hover:bg-muted cursor-pointer"
          >
            {plusInsteadOfPencil ? (
              <PlusCircleIcon className="text-popover-foreground p-2 h-10 w-10" />
            ) : (
              <PencilIcon className="text-popover-foreground p-2 h-10 w-10" />
            )}
          </div>
        )}
      </CardHeader>
      <CardContent className="flex-1">{children}</CardContent>
    </Card>
  );
};
